import axios from 'axios';
import { toast } from 'react-toastify';

// 'http://192.168.1.66:4000/'
const axiosApi = axios.create({
	baseURL: process.env.BASE_URL || 'http://189.113.73.8:8593/',
});

// api.defaults.headers.Conttent-type = `Bearer ${data.token}`;
// axios.defaults.headers.common['Content-Type'] = 'multipart/form-data; boundary=something';

axiosApi.interceptors.response.use((response) => {

	if (response.status === 401) {
		toast.error("Você não esta Autorizado !!!");
	}
	return response;

}, (error) => {
	let erro = '';
	if (error.response) {
		erro = error.response.data;
	}

	else if (error.request) {
		erro = error.request;
	}
	else {
		erro = error.message;
	}

	toast.error(<h6>{erro}</h6>);
	return Promise.reject(error);

});


export default axiosApi




